import Vue from 'vue'
import Filter from './Filter'
import ListItem from './ListItem'
import FavoriteButton from '../players/FavoriteButton.vue'
// Ensure global favorites manager is initialized
import '../firebase/globalInit'

if ( jQuery('#activities').length > 0) {
    console.log('=== ACTIVITIES PAGE DEBUG ===');
    console.log('Firebase config:', window.firebaseConfig);
    console.log('Finding activities container');
    
    // Initialize main Vue app for the activities filter/list
    let app = new Vue({
        components: {
            'activities-filter': Filter,
            'activities-list-item': ListItem,
        },
        el: '#activities',
        data: {
        },
        mounted() {
            console.log('Activities Vue app mounted');
            
            // Check if the FavoriteButton functionality is properly available
            console.log('Checking for favorite button containers...');
            const favButtons = document.querySelectorAll('.favorite-button-container');
            console.log('Found favorite button containers:', favButtons.length);
            
            // Log if global auth state is available
            console.log('Global auth state:', window.cincyAuthState ? 'Available' : 'Missing');
        }
    });

    // Add extra initialization similar to what's in players.js
    // This will directly initialize favorite buttons that might not be caught by the main app
    console.log('Looking for standalone favorite button containers');
    const favoriteBtnContainers = document.querySelectorAll('.favorite-button-container');
    console.log('Found standalone containers:', favoriteBtnContainers.length);
    
    // First, show all Vue containers and hide the default buttons
    favoriteBtnContainers.forEach(container => {
        container.style.display = 'block';
        
        // // Hide the fallback button (the next sibling that's a button)
        // const fallbackBtn = container.nextElementSibling;
        // if (fallbackBtn && fallbackBtn.classList.contains('favorite-button')) {
        //     fallbackBtn.style.display = 'none';
        // }
    });
    
    // Then initialize Vue on each container if not already part of another Vue instance
    favoriteBtnContainers.forEach((container, index) => {
        console.log(`Container ${index} data:`, {
            id: container.dataset.playerId,
            type: container.dataset.itemType || 'activity'
        });
        
        // Check if this container is not already part of a Vue instance
        if (!container.__vue__) {
            console.log(`Mounting Vue instance to container ${index}`);
            
            new Vue({
                el: container,
                components: {
                    FavoriteButton
                }
            });
        } else {
            console.log(`Container ${index} already has a Vue instance`);
        }
    });
}
